import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase/firebase";
import { useEffect, useState } from "react";

function ProtectedRoute({ children }) {

    const [user, setUser] = useState(undefined);

    useEffect(() => {

        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
        });

        return unsubscribe;

    }, []);

    if (user === undefined) {

        return <h2>Loading...</h2>;

    }

    return user ? children : <Navigate to="/Admin" />;

}

export default ProtectedRoute;